import { render, staticRenderFns } from "./excludedKeywordsTable.vue?vue&type=template&id=53610c74&scoped=true&"
import script from "./excludedKeywordsTable.vue?vue&type=script&lang=js&"
export * from "./excludedKeywordsTable.vue?vue&type=script&lang=js&"
import style0 from "./excludedKeywordsTable.vue?vue&type=style&index=0&id=53610c74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53610c74",
  null
  
)

export default component.exports